import { render } from "./DesignSVGUserArt.vue?vue&type=template&id=4be4c0c8&scoped=true"
import script from "./DesignSVGUserArt.vue?vue&type=script&lang=js"
export * from "./DesignSVGUserArt.vue?vue&type=script&lang=js"

import "./DesignSVGUserArt.vue?vue&type=style&index=0&id=4be4c0c8&scoped=true&lang=css"
import "./DesignSVGUserArt.vue?vue&type=style&index=1&id=4be4c0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be4c0c8"]])

export default __exports__